import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import ItineraryMap from './modules/ItineraryMap';
import { StateProvider } from './state/state';
/**
 * Constants
 */
const itineraryMap = document.getElementById('itinerary-drive-map');
if (itineraryMap) {
    const postIn = itineraryMap.getAttribute('data-posts');
    const map = (_jsx(StateProvider, { children: _jsx(ItineraryMap, { postIn: postIn ? postIn : '1' }) }));
    ReactDOM.render(map, itineraryMap);
}
